/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Logout_CrumbInputs */

const en_auth_logout_crumb = /** @type {(inputs: Auth_Logout_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logout`)
};

const pl_auth_logout_crumb = /** @type {(inputs: Auth_Logout_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyloguj się`)
};

/**
* | output |
* | --- |
* | "Logout" |
*
* @param {Auth_Logout_CrumbInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_logout_crumb = /** @type {((inputs?: Auth_Logout_CrumbInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Logout_CrumbInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_logout_crumb(inputs)
	return en_auth_logout_crumb(inputs)
});